import 'react-perfect-scrollbar/dist/css/styles.css';
import {useRoutes} from 'react-router-dom';
import './App.css';
import theme from './theme';
import routes from './routes';
import {ThemeProvider} from "@mui/material";
import {AuthProvider} from "./contexts/AuthContext";
import {NutritionDisplayProvider} from "./contexts/NutritionDisplayProvider";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {MessageProvider} from "./contexts/MessageContext";
import {SearchProvider} from "./contexts/SearchContext";
import StageBanner from "./componenets/common/StageBanner";
import ImpersonationBanner from "./componenets/common/ImpersonationBanner";
import ErrorBoundary from "./componenets/common/ErrorBoundary";
import {AccessDeniedProvider, AccessDeniedGate} from "./contexts/AccessDeniedContext";

const App = () => {
  const content = useRoutes(routes);

  return (
        <ThemeProvider theme={theme}>
          {/* INSIDE ThemeProvider (the fallback is MUI-styled), but OUTSIDE everything else — a
              render error in any provider or page shows the recoverable screen instead of
              unmounting the tree to a blank white page. */}
          <ErrorBoundary>
            <StageBanner />
            <MessageProvider>
              <SearchProvider>
              <AuthProvider>
                <NutritionDisplayProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                    {/* Any 403 from the generated client swaps `content` for the refusal screen.
                        Inside AuthProvider (the copy branches on the caller's role) and wrapping
                        only the routed content, so the layout chrome/nav stays usable. */}
                    <AccessDeniedProvider>
                      <AccessDeniedGate>{content}</AccessDeniedGate>
                    </AccessDeniedProvider>
                    {/* Renders nothing — the visible pill lives in TopNav. This mount exists so the
                        orphaned-impersonation-state cleanup still runs on pages without a TopNav
                        (the login screen), which is where stale state most needs clearing. */}
                    <ImpersonationBanner selfHealOnly />
                </LocalizationProvider>
                </NutritionDisplayProvider>
              </AuthProvider>
              </SearchProvider>
              </MessageProvider>
          </ErrorBoundary>
        </ThemeProvider>
  );
};

export default App;
